import create from 'zustand';
import { PeppolStatusFilter } from 'types/peppolFilter.types';

export type PeppolFiltersData = {
  text: string;
  peppolStatus: PeppolStatusFilter[];
};

type PeppolFiltersStore = {
  filtersData: PeppolFiltersData;
  setSearchValue: (text: string) => void;
  setPeppolStatusFilter: (status: PeppolStatusFilter[]) => void;
  resetFilters: () => void;
};

const initialFiltersData: PeppolFiltersData = {
  text: '',
  peppolStatus: [PeppolStatusFilter.All],
};

const usePeppolFilters = create<PeppolFiltersStore>((set) => ({
  filtersData: initialFiltersData,
  setSearchValue: (text: string) =>
    set((state: PeppolFiltersStore) => ({
      filtersData: { ...state.filtersData, text },
    })),
  setPeppolStatusFilter: (status: PeppolStatusFilter[]) =>
    set((state: PeppolFiltersStore) => ({
      filtersData: { ...state.filtersData, peppolStatus: status },
    })),
  resetFilters: () =>
    set({
      filtersData: initialFiltersData,
    }),
}));

export default usePeppolFilters;
